import { computed, type ComputedRef } from 'vue';
import { useQuery } from 'vue-query';
import productGroupsApi from 'api/product-groups';

export default function useProductGroupsQuery(
  makerId: ComputedRef<number>,
  queryParams: ComputedRef<string>,
  enabled: ComputedRef<boolean>,
) {
  const productGroupsQuery = useQuery(
    ['productGroups', makerId, queryParams],
    () => productGroupsApi.index(makerId.value, queryParams.value),
    {
      enabled,
      keepPreviousData: true,
    },
  );

  const productGroups = computed(() => {
    const data = productGroupsQuery.data.value?.data;
    return (data?.productGroups || []) as ProductGroup[];
  });

  const isProductGroupsLoading = computed(() => productGroupsQuery.isLoading.value);

  return {
    productGroups,
    isProductGroupsLoading,
    productGroupsQuery,
  };
}
